import { generateTranslations } from '../../i18n/translation';

const translations = generateTranslations('datepicker', {
  placeholder: {
    nb: 'Velg dato',
    en: 'Choose a date',
  },
  invalidDate: {
    nb: 'Ugyldig datoformat',
    en: 'Invalid date format',
  },
  dateCannotBeAfterMax: {
    nb: 'Dato kan ikke være etter maks. dato',
    en: 'Date cannot be after max date',
  },
  dateCannotBeBeforeMin: {
    nb: 'Dato kan ikke være før min. dato',
    en: 'Date cannot be before min date',
  },
  weekNo: {
    nb: 'Ukenummer',
    en: 'Week no.',
  },
});

export default translations;
